<template>
  <div class="clean-task">
    <div class="page-search-block">
      <div class="m-b-18">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
        <div class="inline-block">
          <span class="w-90 inline-block align-r m-r-8">日期：</span>
          <el-date-picker
            class="m-r-5"
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD"
          />
          <div class="m-b-18 inline-block">
            <span class="w-90 inline-block align-r m-r-8">保洁员：</span>
            <el-select class="m-r-8 w-120" clearable v-model="search.staffId">
              <el-option
                v-for="cleaner in cleanerList"
                :key="cleaner.id"
                :label="cleaner.name"
                :value="cleaner.id"
              ></el-option>
            </el-select>
          </div>
          <div class="m-b-18 inline-block">
            <span class="w-90 inline-block align-r m-r-8">房源：</span>
            <el-select class="m-r-8 w-120" clearable v-model="search.roomId">
              <el-option
                v-for="room in roomList"
                :key="room.id"
                :label="room.roomName"
                :value="room.id"
              ></el-option>
            </el-select>
          </div>
          <el-button class="submit-btn" size="large" @click="getQuery"
            >搜索</el-button
          >
        </div>
      </div>
    </div>
    <div class="page-operate-block">
      <span class="tit">保洁任务列表</span>
      <div>
        <el-button class="operate-btn" @click="addCleanTask"
          >添加保洁</el-button
        >
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        ref="tenantTable"
        :dataSource="cleanTaskList"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
      >
        >
        <el-table-column
          prop="roomName"
          label="房源"
          show-overflow-tooltip
          width="200"
        >
          <template #default="scope">
            <span
              >{{ scope.row.roomName }}（{{ scope.row.roomTypeName }}）</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="cleanStatus" label="房态" show-overflow-tooltip>
          <template #default="scope"
            ><span>{{
              scope.row.cleanStatus == 1 ? "净房" : "脏房"
            }}</span></template
          >
        </el-table-column>
        <el-table-column
          prop="staffTypeName"
          label="时段"
          show-overflow-tooltip
          width="250"
        >
          <template #default="scope">
            <span>{{ getTaskTimeRange(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" show-overflow-tooltip>
          <template #default="scope">
            <span>{{
              scope.row.status == 1
                ? "未开始"
                : scope.row.status == 2
                ? "保洁中"
                : "已打扫"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="保洁类型" show-overflow-tooltip>
          <template #default="scope">
            <span>{{ scope.row.type == 1 ? "简单" : "标准" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="保洁员"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="price"
          label="费用"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="operate"
          label="操作"
          show-overflow-tooltip
          width="250"
        >
          <template #default="scope">
            <el-button
              class="border-btn primary"
              size="small"
              v-if="scope.row.status === 1"
              @click="checkCleanTaskStatus(scope.row.id, 2, scope.row)"
              >开始任务</el-button
            >
            <el-button
              class="border-btn warn"
              size="small"
              v-if="scope.row.status === 2"
              @click="checkCleanTaskStatus(scope.row.id, 3)"
              >结束任务</el-button
            >
            <el-button
              v-if="scope.row.status != 3"
              class="border-btn primary"
              size="small"
              @click="editCleaner(scope.row.id)"
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.status != 2"
              class="border-btn warn"
              size="small"
              @click="delCleanTask(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </r-table>
    </div>
    <RModal
      :title="currentCleanTaskId ? '编辑保洁任务' : '新增保洁任务'"
      v-model="addCleanTaskModalShow"
      :closeOnClick="false"
      @change="addCleanTaskModalShow = false"
    >
      <template v-slot:content>
        <add-clean-task-modal
          v-if="addCleanTaskModalShow"
          :cleanTaskId="currentCleanTaskId"
          :storeId="storeId"
          :roomList="roomList"
          @close="closeModal"
        ></add-clean-task-modal>
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import addCleanTaskModal from './addCleanTaskModal'
import moment from 'moment'
import { mapActions } from "vuex";

export default {
  components: { RTable, RModal, addCleanTaskModal },
  mixins: [tableMix],
  data() {
    return {
      cleanTaskList: [],
      cleanerList: [],
      roomList: [],
      pagination: { total: 0, pageIndex: 1, pageSize: 20 },
      dateRange: '',
      search: {
        staffId: '',
        roomId: ''
      },
      addCleanTaskModalShow: false,
      currentCleanTaskId: null,
      storeId: null
    }
  },
  computed: {
    getTaskTimeRange() {
      return row => {
        const time = row.taskStartTime.split(' ');
        return time[0] + ' ' + time[1] + '-' + row.taskEndTime.split(' ')[1]
      }
    }
  },
  created() {
    const currShopStr = localStorage.getItem('curShop'),
      currShop = currShopStr && JSON.parse(currShopStr);
    this.storeId = currShop?.id;

    // 监听全局门店切换
    this.getData();
    this.$eventBus.on('change-shop', store => {
      this.storeId = store.id;
      this.getData();
    })
  },

  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },

  methods: {
    ...mapActions(["fetchData"]),

    getData() {
      this.getQuery();
      this.getCleaner();
      this.getRoom();
    },

    // 获取保洁任务列表
    getQuery() {
      let url = 'CLEAN.TASK.GET_LIST';
      let params = { storeId: this.storeId, pageSize: this.pagination.pageSize, pageNumber: this.pagination.pageIndex, ...this.search };
      if (!params.storeId) delete params.storeId

      if (this.dateRange) {
        params['queryDateStart'] = this.dateRange[0] + ' 00:00:00'
        params['queryDateEnd'] = this.dateRange[1] + ' 23:59:59'
      }
      this.fetchData({
        url,
        method: 'get',
        params,
      }).then(res => {
        this.cleanTaskList = res?.data || [];
        this.pagination.total = res?.count || 0
      })
    },

    // 获取当前门店下的保洁人员
    getCleaner() {
      let url = 'CLEAN.CLEANER.GET_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: { storeId: this.storeId, pageSize: 9999, pageNumber: 1 }
      }).then(res => {
        this.cleanerList = res?.data || []
      })
    },

    // 获取当前门店下的房源
    getRoom() {
      let url = 'SAAS.ROOM_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: { storeId: this.storeId, pageSize: 9999, pageNumber: 1 }
      }).then(res => {
        this.roomList = res?.data || []
      })
    },

    // 新增保洁任务
    addCleanTask() {
      this.currentCleanTaskId = null;
      this.addCleanTaskModalShow = true;
    },

    // 编辑保洁人员
    editCleaner(id) {
      this.currentCleanTaskId = id;
      this.addCleanTaskModalShow = true;
    },

    // 开始和结束任务
    checkCleanTaskStatus(cleanTaskId, status, obj={}) {
      if(status == 2 && obj.taskStartTime){
        let startTime = moment(obj.taskStartTime).startOf('day')
        let nowTime = moment()
        if(nowTime<startTime){
          this.$message.error('保洁时间未到')
          return
        }
      }
      if (!cleanTaskId) return;
      this.fetchData({
        url: 'CLEAN.TASK.POST_SAVE',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        params: { id: cleanTaskId, status }
      }).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.getQuery()
        } else {
          this.$message.error('操作失败')
        }
      }).catch(err => {
        this.$message.error('操作失败')
      })
    },

    // 删除
    delCleanTask(cleanTaskId) {
      if (!cleanTaskId) return;
      this.$confirm('确定删除该任务吗？', { type: 'warning' }).then(res => {
        if (res) {
          this.fetchData({
            url: 'CLEAN.TASK.DELETE',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            params: [cleanTaskId]
          }).then(res => {
            if (res) {
              this.$message.success('操作成功')
              this.getQuery()
            } else {
              this.$message.error('操作失败')
            }
          }).catch(err => {
            this.$message.error('操作失败')
          })
        }
      })
    },

    // 关闭新增编辑弹框
    closeModal($event) {
      this.addCleanTaskModalShow = false;
      if ($event === true) {
        this.getQuery();
      }
    },
  }
}
</script>